// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
}

.font-size-1 {
  font-size: 1px !important;
}

.font-size-2 {
  font-size: 2px !important;
}

.font-size-3 {
  font-size: 3px !important;
}

.font-size-4 {
  font-size: 4px !important;
}

.font-size-5 {
  font-size: 5px !important;
}

.font-size-6 {
  font-size: 6px !important;
}

.font-size-7 {
  font-size: 7px !important;
}

.font-size-8 {
  font-size: 8px !important;
}

.font-size-9 {
  font-size: 9px !important;
}

.font-size-10 {
  font-size: 10px !important;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-19 {
  font-size: 19px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-21 {
  font-size: 21px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-23 {
  font-size: 23px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.font-size-25 {
  font-size: 25px !important;
}

.font-size-26 {
  font-size: 26px !important;
}

.font-size-27 {
  font-size: 27px !important;
}

.font-size-28 {
  font-size: 28px !important;
}

.font-size-29 {
  font-size: 29px !important;
}

.font-size-30 {
  font-size: 30px !important;
}

.font-size-31 {
  font-size: 31px !important;
}

.font-size-32 {
  font-size: 32px !important;
}

.font-size-33 {
  font-size: 33px !important;
}

.font-size-34 {
  font-size: 34px !important;
}

.font-size-35 {
  font-size: 35px !important;
}

.font-size-36 {
  font-size: 36px !important;
}

.font-size-37 {
  font-size: 37px !important;
}

.font-size-38 {
  font-size: 38px !important;
}

.font-size-39 {
  font-size: 39px !important;
}

.font-size-40 {
  font-size: 40px !important;
}

.font-size-41 {
  font-size: 41px !important;
}

.font-size-42 {
  font-size: 42px !important;
}

.font-size-43 {
  font-size: 43px !important;
}

.font-size-44 {
  font-size: 44px !important;
}

.font-size-45 {
  font-size: 45px !important;
}

.font-size-46 {
  font-size: 46px !important;
}

.font-size-47 {
  font-size: 47px !important;
}

.font-size-48 {
  font-size: 48px !important;
}

.font-size-49 {
  font-size: 49px !important;
}

.font-size-50 {
  font-size: 50px !important;
}

.font-size-51 {
  font-size: 51px !important;
}

.font-size-52 {
  font-size: 52px !important;
}

.font-size-53 {
  font-size: 53px !important;
}

.font-size-54 {
  font-size: 54px !important;
}

.font-size-55 {
  font-size: 55px !important;
}

.font-size-56 {
  font-size: 56px !important;
}

.font-size-57 {
  font-size: 57px !important;
}

.font-size-58 {
  font-size: 58px !important;
}

.font-size-59 {
  font-size: 59px !important;
}

.font-size-60 {
  font-size: 60px !important;
}

.font-size-61 {
  font-size: 61px !important;
}

.font-size-62 {
  font-size: 62px !important;
}

.font-size-63 {
  font-size: 63px !important;
}

.font-size-64 {
  font-size: 64px !important;
}

.font-size-65 {
  font-size: 65px !important;
}

.font-size-66 {
  font-size: 66px !important;
}

.font-size-67 {
  font-size: 67px !important;
}

.font-size-68 {
  font-size: 68px !important;
}

.font-size-69 {
  font-size: 69px !important;
}

.font-size-70 {
  font-size: 70px !important;
}

.font-size-71 {
  font-size: 71px !important;
}

.font-size-72 {
  font-size: 72px !important;
}

.font-size-73 {
  font-size: 73px !important;
}

.font-size-74 {
  font-size: 74px !important;
}

.font-size-75 {
  font-size: 75px !important;
}

.font-size-76 {
  font-size: 76px !important;
}

.font-size-77 {
  font-size: 77px !important;
}

.font-size-78 {
  font-size: 78px !important;
}

.font-size-79 {
  font-size: 79px !important;
}

.font-size-80 {
  font-size: 80px !important;
}

.font-size-81 {
  font-size: 81px !important;
}

.font-size-82 {
  font-size: 82px !important;
}

.font-size-83 {
  font-size: 83px !important;
}

.font-size-84 {
  font-size: 84px !important;
}

.font-size-85 {
  font-size: 85px !important;
}

.font-size-86 {
  font-size: 86px !important;
}

.font-size-87 {
  font-size: 87px !important;
}

.font-size-88 {
  font-size: 88px !important;
}

.font-size-89 {
  font-size: 89px !important;
}

.font-size-90 {
  font-size: 90px !important;
}

.font-size-91 {
  font-size: 91px !important;
}

.font-size-92 {
  font-size: 92px !important;
}

.font-size-93 {
  font-size: 93px !important;
}

.font-size-94 {
  font-size: 94px !important;
}

.font-size-95 {
  font-size: 95px !important;
}

.font-size-96 {
  font-size: 96px !important;
}

.font-size-97 {
  font-size: 97px !important;
}

.font-size-98 {
  font-size: 98px !important;
}

.font-size-99 {
  font-size: 99px !important;
}

.font-size-100 {
  font-size: 100px !important;
}

body {
  margin: 0;
  font-family: "roboto" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: hsl(0, 0%, 92%) !important;
  color: hsl(217, 24%, 17%) !important;
}

a {
  color: hsl(240, 91%, 69%);
}
a:hover, a:focus {
  color: hsl(240, 91%, 69%);
}
a.no-underline {
  text-decoration: none;
}

.cursor-pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAyDA;;EAEE,YAAA;AAvDF;;AA6DE;EACI,yBAAA;AA1DN;;AAyDE;EACI,yBAAA;AAtDN;;AAqDE;EACI,yBAAA;AAlDN;;AAiDE;EACI,yBAAA;AA9CN;;AA6CE;EACI,yBAAA;AA1CN;;AAyCE;EACI,yBAAA;AAtCN;;AAqCE;EACI,yBAAA;AAlCN;;AAiCE;EACI,yBAAA;AA9BN;;AA6BE;EACI,yBAAA;AA1BN;;AAyBE;EACI,0BAAA;AAtBN;;AAqBE;EACI,0BAAA;AAlBN;;AAiBE;EACI,0BAAA;AAdN;;AAaE;EACI,0BAAA;AAVN;;AASE;EACI,0BAAA;AANN;;AAKE;EACI,0BAAA;AAFN;;AACE;EACI,0BAAA;AAEN;;AAHE;EACI,0BAAA;AAMN;;AAPE;EACI,0BAAA;AAUN;;AAXE;EACI,0BAAA;AAcN;;AAfE;EACI,0BAAA;AAkBN;;AAnBE;EACI,0BAAA;AAsBN;;AAvBE;EACI,0BAAA;AA0BN;;AA3BE;EACI,0BAAA;AA8BN;;AA/BE;EACI,0BAAA;AAkCN;;AAnCE;EACI,0BAAA;AAsCN;;AAvCE;EACI,0BAAA;AA0CN;;AA3CE;EACI,0BAAA;AA8CN;;AA/CE;EACI,0BAAA;AAkDN;;AAnDE;EACI,0BAAA;AAsDN;;AAvDE;EACI,0BAAA;AA0DN;;AA3DE;EACI,0BAAA;AA8DN;;AA/DE;EACI,0BAAA;AAkEN;;AAnEE;EACI,0BAAA;AAsEN;;AAvEE;EACI,0BAAA;AA0EN;;AA3EE;EACI,0BAAA;AA8EN;;AA/EE;EACI,0BAAA;AAkFN;;AAnFE;EACI,0BAAA;AAsFN;;AAvFE;EACI,0BAAA;AA0FN;;AA3FE;EACI,0BAAA;AA8FN;;AA/FE;EACI,0BAAA;AAkGN;;AAnGE;EACI,0BAAA;AAsGN;;AAvGE;EACI,0BAAA;AA0GN;;AA3GE;EACI,0BAAA;AA8GN;;AA/GE;EACI,0BAAA;AAkHN;;AAnHE;EACI,0BAAA;AAsHN;;AAvHE;EACI,0BAAA;AA0HN;;AA3HE;EACI,0BAAA;AA8HN;;AA/HE;EACI,0BAAA;AAkIN;;AAnIE;EACI,0BAAA;AAsIN;;AAvIE;EACI,0BAAA;AA0IN;;AA3IE;EACI,0BAAA;AA8IN;;AA/IE;EACI,0BAAA;AAkJN;;AAnJE;EACI,0BAAA;AAsJN;;AAvJE;EACI,0BAAA;AA0JN;;AA3JE;EACI,0BAAA;AA8JN;;AA/JE;EACI,0BAAA;AAkKN;;AAnKE;EACI,0BAAA;AAsKN;;AAvKE;EACI,0BAAA;AA0KN;;AA3KE;EACI,0BAAA;AA8KN;;AA/KE;EACI,0BAAA;AAkLN;;AAnLE;EACI,0BAAA;AAsLN;;AAvLE;EACI,0BAAA;AA0LN;;AA3LE;EACI,0BAAA;AA8LN;;AA/LE;EACI,0BAAA;AAkMN;;AAnME;EACI,0BAAA;AAsMN;;AAvME;EACI,0BAAA;AA0MN;;AA3ME;EACI,0BAAA;AA8MN;;AA/ME;EACI,0BAAA;AAkNN;;AAnNE;EACI,0BAAA;AAsNN;;AAvNE;EACI,0BAAA;AA0NN;;AA3NE;EACI,0BAAA;AA8NN;;AA/NE;EACI,0BAAA;AAkON;;AAnOE;EACI,0BAAA;AAsON;;AAvOE;EACI,0BAAA;AA0ON;;AA3OE;EACI,0BAAA;AA8ON;;AA/OE;EACI,0BAAA;AAkPN;;AAnPE;EACI,0BAAA;AAsPN;;AAvPE;EACI,0BAAA;AA0PN;;AA3PE;EACI,0BAAA;AA8PN;;AA/PE;EACI,0BAAA;AAkQN;;AAnQE;EACI,0BAAA;AAsQN;;AAvQE;EACI,0BAAA;AA0QN;;AA3QE;EACI,0BAAA;AA8QN;;AA/QE;EACI,0BAAA;AAkRN;;AAnRE;EACI,0BAAA;AAsRN;;AAvRE;EACI,0BAAA;AA0RN;;AA3RE;EACI,0BAAA;AA8RN;;AA/RE;EACI,0BAAA;AAkSN;;AAnSE;EACI,0BAAA;AAsSN;;AAvSE;EACI,0BAAA;AA0SN;;AA3SE;EACI,0BAAA;AA8SN;;AA/SE;EACI,0BAAA;AAkTN;;AAnTE;EACI,0BAAA;AAsTN;;AAvTE;EACI,0BAAA;AA0TN;;AA3TE;EACI,0BAAA;AA8TN;;AA/TE;EACI,0BAAA;AAkUN;;AAnUE;EACI,0BAAA;AAsUN;;AAvUE;EACI,0BAAA;AA0UN;;AA3UE;EACI,0BAAA;AA8UN;;AA/UE;EACI,2BAAA;AAkVN;;AA9UA;EACE,SAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,4CAAA;EACA,oCAAA;AAiVF;;AA9UA;EACE,yBA9Ca;AA+Xf;AA/UE;EAEE,yBAnDW;AAmYf;AA7UE;EACE,qBAAA;AA+UJ;;AA3UA;EACE,eAAA;AA8UF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');\n$clr-danger-900: hsla(0, 89%, 48%, 0.19);\n$clr-danger-450: hsla(5, 99%, 64%, 1);\n$clr-danger-400: hsla(5, 100%, 69%, 1);\n$clr-danger-200: hsla(0, 48%, 83%, 1);\n$clr-primary-900: hsla(237, 69%, 40%, 1);\n$clr-primary-700: hsla(237, 69%, 52%, 1);\n$clr-primary-600: hsla(233, 100%, 57%, 1);\n$clr-primary-400: hsla(237, 40%, 67%, 1);\n$clr-primary-300: hsla(237, 46%, 75%, 1);\n$clr-light-350: hsla(0, 0%, 77%, 0.44);\n$clr-light-450: hsla(0, 0%, 85%, 1);\n$clr-light-500: hsla(0, 0%, 88%, 1);\n$clr-light-600: hsla(0, 0%, 92%, 1);\n$clr-light-700: hsla(0, 0%, 100%, 0.43);\n$clr-light-800: hsla(0, 0%, 98%, 0.83);\n$clr-light-850: hsla(0, 0%, 100%, 0.85);\n$clr-light-95: hsla(0, 0%, 95%, 1);\n$clr-light-900: hsla(0, 0%, 100%, 1);\n$clr-black: rgba(0, 0, 0, 1);\n$clr-black-900: hsla(217, 31%, 6%, 1);\n$clr-black-850: hsla(240, 50%, 4%, 0.69);\n$clr-black-500: hsla(217, 31%, 6%, 0.21);\n$clr-black-25: rgba(0, 0, 0, 0.25);\n$clr-dark-900: hsla(217, 24%, 17%, 1);\n$clr-dark-700: hsla(217, 24%, 17%, 0.788);\n$clr-dark-650: hsla(217, 24%, 17%, 0.35);\n$clr-dark-600: hsla(214, 4%, 39%, 1);\n$clr-dark-630: hsla(214, 4%, 39%, 0.63);\n$clr-dark-500: hsla(217, 1%, 50%, 1);\n$clr-dark-450: hsla(210, 1%, 50%, 1);\n$clr-dark-400: hsla(0, 0%, 97%, 0.78);\n$clr-dark-350: hsla(240, 22%, 95%, 0.22);\n$clr-link-900: hsla(240, 91%, 69%, 1);\n$clr-link-700: hsla(240, 91%, 69%, 1);\n$clr-success-400: hsla(113, 49%, 55%, 0.34);\n\n$clr-dark-300: hsla(214, 4%, 31%, 1);\n$clr-dark-250: hsla(180, 20%, 17%, 1);\n$clr-dark-200: hsla(223, 4%, 66%, 1);\n$clr-dark-150: hsla(217, 24%, 17%, 0.79);\n$clr-light-10: hsla(0, 0%, 71%, 1);\n$clr-light-15: hsla(0, 0%, 92%, 0.69);\n$clr-light-20: hsla(214, 4%, 31%, 0.8);\n$clr-light-25: hsla(0, 0%, 77%, 1);\n$clr-light-30: hsla(0, 0%, 98%, 1);\n$clr-light-35: hsla(0, 0%, 75%, 0.28);\n$clr-light-40: hsla(214, 4%, 31%, 0.79);\n$clr-primary-10: hsla(234, 95%, 92%, 0.37);\n$clr-primary-20: hsla(234, 95%, 92%, 1);\n$clr-link-600: hsla(234, 92%, 56%, 1);\n$clr-success: hsla(217, 24%, 17%, 0.93);\n$clr-table: hsla(213, 7%, 76%, 0.08);\n\n\n\n\nhtml,\nbody {\n  height: 100%;\n}\n\n@for $i from 1 through 100 {\n  $size: 1px * $i;\n\n  .font-size-#{$i} {\n      font-size: $size !important;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: 'roboto' !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: $clr-light-600 !important;\n  color: $clr-dark-900 !important;\n}\n\na {\n  color: $clr-link-700;\n\n  &:hover,\n  &:focus {\n    color: $clr-link-900;\n  }\n\n  &.no-underline {\n    text-decoration: none;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
